import Cookies from "js-cookie"

export const getCurrencyCookie = () => Cookies.get('currency') || 'EUR'

export const getCountryCookie = () => Cookies.get('country') || 'ZZ'

export const getLocaleCookie = () => Cookies.get('locale') || 'en'
